// tslint:disable:no-reserved-keywords
import { Action as ReduxAction } from 'redux'
import { ScreenSizeAction } from '../constants'

/* Action definitions */

export interface ISetPhoneSizeAction extends ReduxAction {
  type: ScreenSizeAction.SET_PHONE_SIZE
}

export interface ISetTabletPortraitSizeAction extends ReduxAction {
  type: ScreenSizeAction.SET_TABLET_PORTRAIT_SIZE
}

export interface ISetTabletLandscapeSizeAction extends ReduxAction {
  type: ScreenSizeAction.SET_TABLET_LANDSCAPE_SIZE
}

export interface ISetDesktopSizeAction extends ReduxAction {
  type: ScreenSizeAction.SET_DESKTOP_SIZE
}

export interface ISetDesktopBigSizeAction extends ReduxAction {
  type: ScreenSizeAction.SET_DESKTOP_BIG_SIZE
}

/* Action creators */

export const setPhoneSizeAction = (): ISetPhoneSizeAction => ({
  type: ScreenSizeAction.SET_PHONE_SIZE,
})

export const setTabletPortraitSizeAction =
  (): ISetTabletPortraitSizeAction => ({
    type: ScreenSizeAction.SET_TABLET_PORTRAIT_SIZE,
  })

export const setTabletLandscapeSizeAction =
  (): ISetTabletLandscapeSizeAction => ({
    type: ScreenSizeAction.SET_TABLET_LANDSCAPE_SIZE,
  })

export const setDesktopSizeAction = (): ISetDesktopSizeAction => ({
  type: ScreenSizeAction.SET_DESKTOP_SIZE,
})

export const setDesktopBigSizeAction = (): ISetDesktopBigSizeAction => ({
  type: ScreenSizeAction.SET_DESKTOP_BIG_SIZE,
})

export type ScreenSizeActions =
  ISetPhoneSizeAction |
  ISetTabletPortraitSizeAction |
  ISetTabletLandscapeSizeAction |
  ISetDesktopSizeAction |
  ISetDesktopBigSizeAction
